<!--
  ~ Copyright (c) 2022-2026 GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->

<div class="gm-main-header">
    <div class="header-col">
        <a class="navbar-image d-none d-lg-block me-2" routerLink='/'>
            <img src="../assets/images/GM_logo_pos_Blue500_RGB.svg" alt="GM" />
        </a>
    </div>
    <span class="title navbar-brand" routerLink='/'>eSCI Tools</span>
</div>
